import { render, staticRenderFns } from "./ProviderRegionContent.vue?vue&type=template&id=a6b60728"
import script from "./ProviderRegionContent.vue?vue&type=script&lang=js"
export * from "./ProviderRegionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports